import { getFormattedCell } from '../components/excel-export/excel.formatter';
import { ColumnDefinition } from '../../models/column';
import { GameDayModel } from '../../models/gameday-model';
import { ViewOrder } from '../mappers/gameDay-orders.transfomations';
import { RawReportsData, TabSettings, FormattedCell } from '../models/report';

export abstract class ExportBaseService {
  protected createTab({
    name,
    header,
    data,
    totals,
    priority,
    orderMapper
  }: RawReportsData): TabSettings {
    return {
      name,
      header: this.transformHeadersToExcelRow(header),
      totals: this.transformTotalsToExcelRow(header, totals),
      table: this.transformDataToExcelTable(header, data, orderMapper),
      priority
    };
  }

  private transformHeadersToExcelRow(columns: ColumnDefinition[]) {
    return columns.map(column => column.label);
  }

  private transformTotalsToExcelRow(
    columns: ColumnDefinition[],
    totals: any
  ): FormattedCell[] {
    return columns
      .map(({ field }) => {
        const [totalField] = Object.keys(totals).filter(key => key === field);

        if (field === totalField) {
          return getFormattedCell(totalField, totals[totalField]);
        }

        return undefined;
      })
      .filter(column => !!column);
  }

  // tslint:disable:no-null-keyword
  private transformDataToExcelTable(
    columns: ColumnDefinition[],
    rows: any[] = [],
    orderMapper: (item: GameDayModel.Order) => ViewOrder = null
  ): FormattedCell[][] {
    return rows.map(row => {
      const data = (!!orderMapper && orderMapper(row as any)) || row;
      const keys = Object.keys(data);

      return columns
        .map(column => {
          const [field] = keys.filter(key => key === column.field);

          if (column.field === field) {
            return getFormattedCell(field, data[field]);
          }

          return undefined;
        })
        .filter(column => !!column);
    });
  }
}
